import { useMemo } from "react";
import { Tooltip } from "react-tooltip";
import { v4 as uuidv4 } from "uuid";

import TruncateText from "components/TruncateText";

import cn from "lib/cn";

import { TTabeField, TTableRecord } from "../../types";

export interface FieldTextArrayProps {
  field?: TTabeField;
  record?: TTableRecord;
  firstItemClass?: string;
}

const FieldTextArray = ({
  field,
  record,
  firstItemClass,
}: FieldTextArrayProps) => {
  const value = useMemo(() => {
    const val = field?.key ? record?.[field.key] : "";

    return val;
  }, [record, field]);

  const tooltipId = useMemo(() => {
    return uuidv4();
  }, []);

  const handleClickView = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
  };

  if (!value || !value.length) return <>-</>;

  return (
    <div
      className={cn([
        "text-neutral-night flex gap-2 items-center justify-start",
        field?.className,
      ])}
    >
      <div
        className={cn(
          "flex justify-center items-center max-w-[11rem]",
          firstItemClass
        )}
      >
        <TruncateText id={value?.[0]} text={value?.[0]}>
          {value?.length ? value?.[0] : "-"}
        </TruncateText>
      </div>

      {value?.length > 1 && (
        <>
          <div
            data-tooltip-id={tooltipId}
            className="text-sm bg-gray-50 border border-gray-100 justify-center flex items-center rounded-xl w-10 min-w-10  h-6 p-0 cursor-pointer"
            onClick={handleClickView}
          >
            +{value?.length - 1}
          </div>
          <Tooltip
            id={tooltipId}
            place="right-start"
            style={{
              width: value?.length > 10 ? "27.3rem" : "auto",
              height: "auto",
              zIndex: "20",
            }}
          >
            {value?.length > 11 ? (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                }}
              >
                <span className="font-medium text-sm">
                  {value?.slice(1, value?.length).join(", ")}
                </span>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {value
                  ?.slice(1, value?.length)
                  .map((item: string, index: number) => {
                    return (
                      <span key={index} className="font-medium text-sm">
                        {item}
                      </span>
                    );
                  })}
              </div>
            )}
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default FieldTextArray;
